import { useEffect } from 'react';
import { OrganisationServiceRoot } from 'src/apis/organisation-service/types';
import { isServerError, useAxios } from 'src/hooks/use-axios';
import { useToast } from 'src/hooks/use-toasts';
import { handleRequestErrorWithNotification } from 'src/utils/axios-config';

export function useOrganisationService() {
  const organisationService = useAxios(
    (axios, signal) =>
      axios.request<OrganisationServiceRoot>({
        signal,
        url: PRISMA_CONFIG.organisationService,
      }),
    { neededOnPageLoad: true, cacheKey: 'organisation-service-root' }
  );

  useEffect(() => {
    organisationService.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return organisationService;
}

export type OrganisationServiceRequest = ReturnType<
  typeof useOrganisationService
>;

export function useOptionalOrganisationService() {
  const notify = useToast();

  const organisationService = useAxios(
    (axios, signal) =>
      axios.request<OrganisationServiceRoot>({
        signal,
        url: PRISMA_CONFIG.organisationService,
        timeout: 5000,
      }),
    {
      neededOnPageLoad: true,
      cacheKey: 'organisation-service-root',
      onError(error) {
        if (!isServerError(error, 401)) {
          handleRequestErrorWithNotification({
            error,
            notify,
            setReauthenticate: () => {},
          });
        }
        return error;
      },
    }
  );

  useEffect(() => {
    organisationService.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return organisationService;
}
